import { reconcileMoneyParts } from '@shared/lib/money/display-reconciliation'
import type { DisplayMoney } from '@shared/lib/money/display-reconciliation'
import { MoneyValue } from '../MoneyValue/MoneyValue'
import { body } from './MoneyReconciliation.css'

export function MoneyRoundingNote({
  total,
  parts,
}: {
  total: DisplayMoney
  parts: readonly DisplayMoney[]
}) {
  const result = reconcileMoneyParts(total, parts)
  if (result.kind !== 'rounding') return null
  return (
    <span className={body} role="note" aria-label="Arredondamento dos valores">
      Valores arredondados para exibição. Diferença na soma:{' '}
      <MoneyValue {...result.difference} size="sm" />.
    </span>
  )
}
